import React, { FunctionComponent } from 'react';

import { Carousel, ProductCard, ProductCardProps } from '@savebetter/components';

interface ProductCardsSequencerProps {
  slidesData?: Array<ProductCardProps | undefined>;
  className?: string;
}

const settings = {
  lg: {
    slidesPerPage: 3
  },
  md: {
    slidesPerPage: 2,
    offset: 25
  }
};

export const ProductCardsSequencer: FunctionComponent<React.PropsWithChildren<ProductCardsSequencerProps>> = ({
  className = '',
  slidesData
}): React.ReactElement => {
  if (!slidesData) {
    return <span>something went wrong</span>;
  }

  const slides = slidesData.map(
    (slideData, slideIndex) => slideData && <ProductCard {...slideData} key={slideIndex} />
  );

  return (
    <Carousel
      settings={settings}
      useDefaultSlideWrapper={false}
      contentLabel="Products"
      slides={slides}
      className={className}
    />
  );
};
